import { render, staticRenderFns } from "./loginPage.vue?vue&type=template&id=ada7b022&"
import script from "./loginPage.vue?vue&type=script&lang=js&"
export * from "./loginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada7b022')) {
      api.createRecord('ada7b022', component.options)
    } else {
      api.reload('ada7b022', component.options)
    }
    module.hot.accept("./loginPage.vue?vue&type=template&id=ada7b022&", function () {
      api.rerender('ada7b022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/login_page/loginPage.vue"
export default component.exports